import React, { useState, useEffect } from "react";

export enum RadioOptionsEnum {
     All = "ALL",
     Yes = "YES",
     No = "NO",
}


interface RadioYesNoAllProps {
     handler: any;
     value: string;
     targetVariable: string;
}

function RadioYesNoAll({ handler, value: propValue, targetVariable }: RadioYesNoAllProps) {
     const [selectedValue, setSelectedValue] = useState(propValue);

     // Sync with props (replaces getDerivedStateFromProps)
     useEffect(() => {
          setSelectedValue(propValue);
     }, [propValue]);

     const myClickHandler = (inEvent: any): void => {
          handler(targetVariable, inEvent.target.value);
     };

     return (
          <div>
               <label>
                    <input type="radio"
                         name={"rdoYesNoAny_"+ targetVariable}
                         id={"rdoYesNoAny_"+ targetVariable + "_all"}
                         value={RadioOptionsEnum.All}
                         checked={selectedValue === RadioOptionsEnum.All}
                         onChange={myClickHandler}
                    />
                    <span>All</span>
               </label>
               &nbsp;&nbsp;
               <label>
                    <input type="radio"
                         name={"rdoYesNoAny_"+ targetVariable}
                         id={"rdoYesNoAny_"+ targetVariable + "_yes"}
                         value={RadioOptionsEnum.Yes}
                         checked={selectedValue === RadioOptionsEnum.Yes}
                         onChange={myClickHandler}
                    />
                    <span>Yes</span>
               </label>
               &nbsp;&nbsp;
               <label>
                    <input type="radio"
                         name={"rdoYesNoAny_"+ targetVariable}
                         id={"rdoYesNoAny_"+ targetVariable + "_no"}
                         value={RadioOptionsEnum.No}
                         checked={selectedValue === RadioOptionsEnum.No}
                         onChange={myClickHandler}
                    />
                    <span>No</span>
               </label>
          </div>
     )
}

export default RadioYesNoAll;
